"use client"

import Image from "next/image"
import { styled } from "./ui"

export const NextImage = styled(Image, {
  forwardProps: ["fill", "height", "width"],
})
